import React, { useRef } from "react";
import { CheckoutRegularPopupContainer } from "./CheckoutRegularPopup.container";
import { WidePopup, CourseCheckout } from "@obby/components";
import { TicketTypeBookingTypes } from "@obby/constants";
import * as settings from "~/settings";

export function CheckoutRegularPopupView() {
  const {
    user,
    ticketTypes,
    course,
    tutors,
    locations,
    actions
  } = CheckoutRegularPopupContainer.useContainer();

  const popupWrapperRef = useRef();

  const courseIsSoldOut =
    course.summary.hasDates && !course.summary.hasAvailableDates;

  function onStepChange() {
    popupWrapperRef.current.scrollTo({
      top: 0
    });
  }

  return (
    <WidePopup onClose={actions.onClose} wrapperRef={popupWrapperRef}>
      <CourseCheckout
        course={course}
        courseId={course._id}
        courseThumbnail={course.galleryImagesHuge?.[0]?.url}
        courseTitle={course.title}
        courseType={course.type}
        discount={course.discount}
        locations={locations}
        isBundleEnabled={course.bundles.length > 0}
        isSendingMaterial={course.requiresSendingPhysicalMaterial}
        isSoldOut={courseIsSoldOut}
        isTrialEnabled={course.summary.hasAvailableTermTrialDates}
        onGetPaymentIntent={actions.onGetPaymentIntent}
        onStepChange={onStepChange}
        onValidateDiscount={actions.onValidateDiscount}
        onConfirmFreeBooking={actions.onConfirmFreeBooking}
        onLoadDates={actions.onLoadMoreDates}
        onLogin={actions.onCheckoutLogin}
        onViewBundlesClick={actions.onViewBundlesClick}
        onViewTrialClick={actions.onViewTrialClick}
        openWaitingListPopup={actions.openWaitingListPopup}
        schoolId={course.schoolId}
        stripePublicKey={settings.stripe.publicKey}
        ticketTypes={ticketTypes.filter(
          ticketType =>
            ticketType.bookingType === TicketTypeBookingTypes.REGULAR
        )}
        tutors={tutors}
        user={user}
        userInputs={course.userInputs}
      />
    </WidePopup>
  );
}
